import { ApplicationTaxInformationScreen } from "@/interactors/ApplicationTaxInformationScreen";

export default function TaxInformation() {
  return <ApplicationTaxInformationScreen />;
}
